

































































































import { Component, Vue, Prop } from 'vue-property-decorator';

import { curApiService, ApiService } from '@/services/ApiService';

import moment from 'moment';
import tippy from 'tippy.js';
import { BaseStation } from '@/types';

@Component({
  components:{

  }
})
export default class BaseStationRowMobile extends Vue {

  @Prop({ default: {},  type: Object}) baseStation!: BaseStation;
  @Prop({ default: 0,  type: Number}) index!: number;
  
  error:string = '';

  curSection:'info'|'connection'|'healthTraffic'|'backhauls'|'location' = 'info';

    
  async mounted() {
    tippy('[data-tippy-content]');
  }

  formatTs(ts:number|undefined): {time: string, ago: string} {

    return {
      time: ts ? moment(ts).format('L LT') : 'N/A',
      ago: ts ? moment(ts).fromNow() : 'N/A'
    };
  }

  formatName(name:string): string {
    if(name.length <= 30)
      return name;
    return name.substring(0, 27) + '...';
  }

  goLeft() {

    switch(this.curSection) {
      case 'info': this.curSection = 'location'; break;
      case 'connection': this.curSection = 'info'; break;
      case 'healthTraffic': this.curSection = 'connection'; break;
      case 'backhauls': this.curSection = 'healthTraffic'; break;
      case 'location': this.curSection = 'backhauls'; break;
    }

  }

  goRight() {

    switch(this.curSection) {
      case 'info': this.curSection = 'connection'; break;
      case 'connection': this.curSection = 'healthTraffic'; break;
      case 'healthTraffic': this.curSection = 'backhauls'; break;
      case 'backhauls': this.curSection = 'location'; break;
      case 'location': this.curSection = 'info'; break;
    }
  }
}

